import { setLoading, setStep } from "../../redux/payment/slice";
import { PAYMENT_STEPS } from "../../types/PaymentMethodsTypes";

export const dispatchError = (error, dispatch) => {
  dispatch(setLoading(false));
  if (error.error.data.statusCode === 409) {
    dispatch(setStep(PAYMENT_STEPS.ATTENTION));
  } else if (
    error.error.data.errorCode &&
    error.error.data.errorCode === "TRANSACTION.ALREADY_ACTIVATED"
  ) {
    dispatch(setStep(PAYMENT_STEPS.TRANSACTION_ERROR));
  } else {
    // dispatch(setErrors(""));
    dispatch(setStep(PAYMENT_STEPS.FAILED));
  }
};
